export const FAMILY_GOLF_TEMPLATE_SLUG = 'family-golf'

export const isFamilyGolfTemplateSelected = (
  groupEventTemplates = [],
  templateId,
) =>
  Boolean(templateId) &&
  groupEventTemplates.some(
    template =>
      String(template.id) === String(templateId) &&
      template.slug === FAMILY_GOLF_TEMPLATE_SLUG,
  )

export const canSubmitCreateEvent = ({
  canBuildOwnEvent = false,
  isPgaHopeCoach = false,
  isPgaHopeEvent = false,
  isFamilyGolfTemplate = false,
} = {}) =>
  canBuildOwnEvent || (isPgaHopeCoach && isPgaHopeEvent) || isFamilyGolfTemplate
